import { PERSONA_INITIAL_OBJECT } from '@/config/settings';
import { getDivisionsWithBrand } from '@/services/brand';

export const brandSlice = (set, get): BrandContextStore => ({
  division: '',
  brand: { id: '', name: '' },
  persona: PERSONA_INITIAL_OBJECT,
  allDivisions: [],
  brandDetails: {},
  agentAlreadyExists: false,
  brandDoc: false,
  isPreview: false,
  privewApiPayload: {},
  previewPersonas: [],
  selectedPreviewPersona: PERSONA_INITIAL_OBJECT,
  setDivision: (division) => set(() => ({ division: division })),
  setBrand: (brand) => set(() => ({ brand: brand })),
  setPersona: (persona) => set(() => ({ persona: persona })),
  setAllDivisions: (divisions) => set(() => ({ allDivisions: divisions })),
  setBrandDetails: (brandDetail) => set(() => ({ brandDetails: brandDetail })),
  setAgentAlreadyExists: (val) => set(() => ({ agentAlreadyExists: val })),
  setBrandDoc: (val) => set(() => ({ brandDoc: val })),
  setIsPreview: (val) => set(() => ({ isPreview: val })),
  setPreviewApiPayload: (payload) => set(() => ({ privewApiPayload: payload })),
  setSelectedPreviewPersona: (persona) => set(() => ({ selectedPreviewPersona: persona })),
  setPreviewPersonas: (personas) => set(() => ({ previewPersonas: personas })),
  getDivisionAndBrands: async () => {
    const response = await getDivisionsWithBrand();
    set(() => ({ allDivisions: response }));
  },
  brandInit: async () => {
    const { getDivisionAndBrands } = get();
    await getDivisionAndBrands();
  },
});
